module.exports = __webpack_public_path__ + "img/folder-plus.819e77a4.svg";